import React, { useState, useEffect, useCallback } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import debounce from 'lodash/debounce';

import Input from '../../../Input';

let AlgoliaInput = ({ refine, delay, ...props }) => {
  const [value, setValue] = useState('');
  const debouncedRefine = useCallback(debounce(refine, delay), [refine]);
  useEffect(() => {
    if (typeof debouncedRefine?.cancel === 'function')
      debouncedRefine?.cancel();
    debouncedRefine(value);
  }, [value, debouncedRefine, refine]);
  return (
    <Input
      value={value}
      onChange={e => setValue(e.currentTarget.value)}
      {...props}
    />
  );
};

AlgoliaInput = connectSearchBox(AlgoliaInput);

AlgoliaInput.defaultProps = {
  delay: 1000,
};

export default AlgoliaInput;
